import { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai';
import { Button, ButtonGroup, Stack } from '@mui/material';
import {
  AlignedBoundingBox,
  rotatedVisibilityBoxFromAligned,
  VisibilityBoxMode,
} from '@fabric-web/3d-viewer';
import * as globalState from '@/state';

type Props = {
  defaultBoundingBox?: AlignedBoundingBox;
};

export const VisibilityBoxPanel = ({ defaultBoundingBox }: Props) => {
  const [currentVisibilityBox, setCurrentVisibilityBox] = useAtom(globalState.currentVisibilityBox);

  const isEnabled = useMemo(() => {
    return currentVisibilityBox.mode !== VisibilityBoxMode.Disabled;
  }, [currentVisibilityBox.mode]);

  const isEditMode = useMemo(() => {
    return currentVisibilityBox.mode === VisibilityBoxMode.Adjusting;
  }, [currentVisibilityBox.mode]);

  const setVisibilityBoxMode = useCallback(
    (newMode: VisibilityBoxMode) => {
      setCurrentVisibilityBox((current) =>
        current.mode === newMode
          ? current
          : {
              ...current,
              mode: newMode,
            }
      );
    },
    [setCurrentVisibilityBox]
  );

  const resetVisibilityBox = useCallback(() => {
    if (!defaultBoundingBox) return;
    // eslint-disable-next-line no-console
    console.log('defaultBoundingBox', defaultBoundingBox);
    setCurrentVisibilityBox((current) => {
      return {
        ...rotatedVisibilityBoxFromAligned({
          ...current,
          ...defaultBoundingBox,
          mode: VisibilityBoxMode.Enabled,
        }),
      };
    });
  }, [setCurrentVisibilityBox, defaultBoundingBox]);

  return (
    <Stack>
      <ButtonGroup>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setVisibilityBoxMode(VisibilityBoxMode.Adjusting)}
          disabled={isEditMode}
          sx={{ width: 'auto' }}
        >
          Adjust Visibility Box
        </Button>
        {isEditMode && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => resetVisibilityBox()}
            disabled={!resetVisibilityBox || !isEnabled || !isEditMode}
          >
            Reset
          </Button>
        )}
        {isEditMode && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setVisibilityBoxMode(VisibilityBoxMode.Enabled)}
            disabled={!isEnabled || !isEditMode}
          >
            Done
          </Button>
        )}
      </ButtonGroup>
    </Stack>
  );
};
